const STORAGE_KEYS = [
  'id_token',
  'access_token',
  'user_profile',
  'user_id',
];

export function normalizeFirebaseUser(firebaseUser) {
  if (!firebaseUser) {
    return null;
  }

  return {
    sub: firebaseUser.uid,
    uid: firebaseUser.uid,
    email: firebaseUser.email || '',
    name: firebaseUser.displayName || '',
    picture: firebaseUser.photoURL || '',
  };
}

export function persistUserSession(firebaseUser) {
  const normalizedUser = normalizeFirebaseUser(firebaseUser);

  if (!normalizedUser) {
    clearUserSession();
    return null;
  }

  localStorage.setItem('user_profile', JSON.stringify(normalizedUser));
  localStorage.setItem('user_id', normalizedUser.uid);
  return normalizedUser;
}

export function getStoredUserProfile() {
  try {
    const profile = localStorage.getItem('user_profile');
    return profile ? JSON.parse(profile) : null;
  } catch (error) {
    console.error('Failed to parse cached user profile', error);
    return null;
  }
}

export function clearUserSession() {
  STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}

